import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";
import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import {
  boldenBacktickText,
} from "apps/website/utils/website/boldenBacktickText";
import Illustration from "apps/website/components/base/Illustration/Illustration";
import Image from "apps/website/components/base/Image/Image";
import SimpleTag from "apps/website/components/base/Tag/v2/SimpleTag/SimpleTag";
import cx from "apps/website/utils/misc/cx";

import { IEducationalCard } from "../MessagingCard.map";

const IMAGE_SIZE_CLASSNAME = "size-[72px]";

const CardMedia = (
  { image, illustration, title }: Pick<IEducationalCard, "image" | "illustration" | "title">,
) => {
  if (image) {
    return (
      <div className={cx("relative shrink-0 overflow-hidden", IMAGE_SIZE_CLASSNAME)}>
        <Image
          image={image}
          alt={image.alt ?? title ?? ""}
          className="h-full w-full"
          imageClassName="h-full w-full object-contain"
        />
      </div>
    );
  }

  if (illustration) {
    return <Illustration className="shrink-0" size="medium" {...illustration} />;
  }

  return null;
};

export const EducationalCard = (
  { title, titleTag, description, footer, illustration, image }: IEducationalCard,
) => {
  const heading = title ? <TextSubtitle size={3}>{ title }</TextSubtitle> : null;

  return (
    <div className="flex flex-col gap-2" data-component={EducationalCard.name}>
      <div className={cx("flex gap-2", image && "items-center")}>
        <CardMedia image={image} illustration={illustration} title={title} />

        <div className="flex flex-col gap-1">
          { titleTag && heading ? (
            <div className="flex flex-wrap items-center gap-1">
              { heading }
              <SimpleTag
                label={titleTag}
                bgColor="pink"
                rotation={-1}
                size={4}
                data-testid="educational-card-title-tag"
              />
            </div>
          ) : heading }

          { typeof description === "string" ? (
            <TextBody size={4}>{ boldenBacktickText(description) }</TextBody>
          ) : (
            description
          ) }
        </div>
      </div>
      { footer && <TextBody size={3}>{ footer }</TextBody> }
    </div>
  );
};
